<template>
  <div class="modal" @mousedown.self.stop="cancel" @touchstart.self.stop="cancel">
    <slot name="roof" />
    <div class="modal-container">
      <header><slot name="header" /></header>
      <div class="modal-body">
        <slot name="body" />
      </div>
      <footer>
        <slot name="footer" />
      </footer>
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import EscapeToCancelMixin from 'vuemixins/escape_to_cancel_mixin'
import EnterToConfirmMixin from 'vuemixins/enter_to_confirm_mixin'

export default {
  mixins: [EscapeToCancelMixin, EnterToConfirmMixin],
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    confirm() {
      this.$emit('confirm')
    },
  },
}
</script>
